import { Types } from "../actionTypes";
import { createSelector } from "@reduxjs/toolkit";
import { categoryMapper, sortedCategoriesByKey } from "../utils/categoryHelpers";
import { categoryKeys } from "@Src/constants/Categories";
export const initialState = {};

const categories = (state = initialState, action) => {
  switch (action.type) {
    case Types.FETCHING_CATEGORIES_SUCCESS: {
      const data = categoryMapper(action.data, state.travelTabs, state.program_key);
      return {
        ...state,
        data: getFilteredCategories(data, state),
      };
    }
    case Types.FETCHING_PROGRAM_SUCCESS:
      return {
        ...state,
        program_key: action.data.program_key,
        travelTabs: action.data.travel.tab_detail,
      };
    default:
      return state;
  }
};

function getFilteredCategories(data, state) {
  const excludedGroceryCouponPcids = process.env.REACT_APP_EXCLUDED_GROCERY_COUPONS_PCIDS;
  const result = data.categories.map((category) => {
    const subCategories = category?.subcategories?.filter((subCategory) => {
      if (
        categoryKeys.GROCERY_COUPONS === subCategory.category_key &&
        excludedGroceryCouponPcids.includes(state.program_key)
      ) {
        return false;
      }
      return true;
    });
    return {
      ...category,
      subcategories: [...subCategories],
    };
  });
  return {
    ...data,
    categories: [...result],
  };
}

export const getCategories = createSelector([(state) => state.data], (data) => {
  // We can manipulate the data here to return an object that has a similar shape
  return data ? data.categories : [];
});

export const getHeaderCategories = createSelector([(state) => state.data], (data) => {
  if (!data) return null;

  // See ticket DD-1537 for order
  const sortedCatKeys = [
    categoryKeys.TRAVEL,
    categoryKeys.THEMEPARKS,
    categoryKeys.EAT,
    categoryKeys.PLAY,
    categoryKeys.SHOP,
  ];

  const sortedCats = sortedCategoriesByKey(sortedCatKeys, data.categories);

  return sortedCats;
});

export const getDropdownCategories = createSelector([(state) => state.data], (data) => {
  if (!data) return null;
  // See ticket PD-1365 for order
  const sortedCatKeys = [
    categoryKeys.HOTELS,
    categoryKeys.THEMEPARKS,
    categoryKeys.CARS,
    categoryKeys.FLIGHTS,
    categoryKeys.EVENTS,
    categoryKeys.ACTIVITIES,
    categoryKeys.EAT,
    categoryKeys.PLAY,
    categoryKeys.SHOP,
    categoryKeys.HOT_DEALS,
  ];

  const sortedCats = sortedCategoriesByKey(sortedCatKeys, data.categories);

  return sortedCats;
});

export const getTravelCategories = createSelector([(state) => state.data], (data) => {
  if (!data) return null;

  // See ticket DD-1537 for order
  const sortedCatKeys = [
    categoryKeys.HOTELS,
    categoryKeys.CARS,
    categoryKeys.ACTIVITIES,
    categoryKeys.FLIGHTS,
    categoryKeys.THEMEPARKS,
  ];

  const sortedCats = sortedCategoriesByKey(sortedCatKeys, data.categories);

  return sortedCats;
});

export const getEatCategories = createSelector([(state) => state.data], (data) => {
  if (!data) return null;

  let eatSubCats = data.categories.reduce((accum, cat, index) => {
    if (cat.category_key === categoryKeys.EAT) {
      accum.push(...cat.subcategories);
    }
    if (cat.category_key === categoryKeys.GROCERY_COUPONS) {
      accum.push(cat);
    }

    return accum;
  }, []);

  return eatSubCats;
});

export const getPlayCategories = createSelector([(state) => state.data], (data) => {
  if (!data) return null;

  const sortedCatKeys = [
    categoryKeys.MOVIES,
    categoryKeys.GOLF,
    categoryKeys.SKI_SNOWBOARD,
    categoryKeys.CONCERTS_EVENTS,
    categoryKeys.MUSEUMS_ZOOS_TOURS,
    categoryKeys.OUTDOOR_ADVENTURE,
    categoryKeys.SPORTING_EVENTS,
  ];

  const sortedCats = sortedCategoriesByKey(sortedCatKeys, data.categories);
  return sortedCats;
});

export const getShopCategories = createSelector([(state) => state.data], (data) => {
  if (!data) return null;

  const sortedCatKeys = [
    categoryKeys.APPAREL_ACCESSORIES,
    categoryKeys.ART,
    categoryKeys.CRAFTS,
    categoryKeys.ELECTRONICS,
    categoryKeys.FURNITURE,
    categoryKeys.GIFTS,
    categoryKeys.OFFICE_SUPPLIES,
    categoryKeys.OTHER_SHOPPING,
    categoryKeys.SPORTING_GOODS,
  ];

  const sortedCats = sortedCategoriesByKey(sortedCatKeys, data.categories);
  return sortedCats;
});

export const getCategoriesMobileMenu = (state) => {
  return state.data?.categories
    .filter((category) => category.category_key < 2000)
    .map((category) => ({
      id: category.category_key,
      name: category.category_name,
      parentCategory: category.category_parent_key,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
};

export default categories;
